import { useState } from 'react';
import { RevealBox, SectionLabel, SectionTitle } from './UI';

const details = [
  { icon:'📞', title:'Call Us Directly', info:'+91 86920 16247', sub:'Mon–Sat, 9 AM to 7 PM IST' },
  { icon:'💬', title:'WhatsApp Support', info:'Instant Response', sub:'Get answers in minutes' },
  { icon:'📧', title:'Email Us', info:'admission@igradeeducation.com', sub:'Response within 2 hours' },
  { icon:'📍', title:'Head Office', info:'Address - 701, Centurion Business park , Wagle Estate , Rd no - 16 Thane(West) 400604', sub:'PAN-India operations' },
];

const socials = [
  {
    name: 'Facebook',
    href: 'https://www.facebook.com/igradeeducation',
    color: '#1877F2',
    hoverShadow: 'rgba(24,119,242,0.35)',
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="#fff">
        <path d="M24 12.073C24 5.405 18.627 0 12 0S0 5.405 0 12.073C0 18.1 4.388 23.094 10.125 24v-8.437H7.078v-3.49h3.047V9.41c0-3.025 1.792-4.697 4.533-4.697 1.312 0 2.686.236 2.686.236v2.97h-1.513c-1.491 0-1.956.93-1.956 1.874v2.25h3.328l-.532 3.49h-2.796V24C19.612 23.094 24 18.1 24 12.073z"/>
      </svg>
    ),
  },
  {
    name: 'Instagram',
    href: 'https://www.instagram.com/igrade_education/',
    color: '#E1306C',
    hoverShadow: 'rgba(225,48,108,0.35)',
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="#fff">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
      </svg>
    ),
  },
  {
    name: 'LinkedIn',
    href: 'https://www.linkedin.com/company/igrade-education/',
    color: '#0A66C2',
    hoverShadow: 'rgba(10,102,194,0.35)',
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="#fff">
        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
      </svg>
    ),
  },
];

export default function Contact() {
  const [form, setForm] = useState({ name:'', phone:'', email:'', course:'', university:'', message:'' });
  const [step, setStep] = useState(0);
  const [errors, setErrors] = useState({});

  const validate = () => {
    const e = {};
    if (!form.name.trim()) e.name = 'Required';
    if (!form.phone.trim() || form.phone.replace(/\D/g,'').length < 10) e.phone = 'Valid phone required';
    if (!form.email.includes('@')) e.email = 'Valid email required';
    if (!form.course) e.course = 'Please select a course';
    return e;
  };

  const SHEET_URL = 'https://script.google.com/macros/s/AKfycbw5Ry5L04-0-jgTmW1X9vJeOxn5__VPx0VaTypzppvi9xw-IQbhyTEA6zGhWyoyIUEK/exec';

  const submit = async () => {
    const e = validate();
    if (Object.keys(e).length) { setErrors(e); return; }
    setStep(1);
    try {
      await fetch(SHEET_URL, {
        method: 'POST',
        mode: 'no-cors',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: form.name, phone: form.phone, email: form.email,
          course: form.course, university: form.university, message: form.message,
        }),
      });
    } catch (err) { console.error('Sheet error:', err); }
    setStep(2);
  };

  const inp = (field, placeholder, type='text', opts) => (
    <div style={{ marginBottom:0 }}>
      {opts ? (
        <select value={form[field]} onChange={e => { setForm({...form,[field]:e.target.value}); setErrors({...errors,[field]:''}); }}
          style={{ width:'100%', border:`1.5px solid ${errors[field]?'#e53e3e':'var(--graylt)'}`, borderRadius:10, padding:'13px 16px', fontSize:15, fontFamily:'DM Sans,sans-serif', color:form[field]?'var(--navy3)':'var(--gray)', background:'var(--white)', outline:'none', transition:'border 0.2s' }}>
          <option value="">{placeholder}</option>
          {opts.map(o => <option key={o} value={o}>{o}</option>)}
        </select>
      ) : (
        <input type={type} placeholder={placeholder} value={form[field]}
          onChange={e => { setForm({...form,[field]:e.target.value}); setErrors({...errors,[field]:''}); }}
          style={{ width:'100%', border:`1.5px solid ${errors[field]?'#e53e3e':'var(--graylt)'}`, borderRadius:10, padding:'13px 16px', fontSize:15, fontFamily:'DM Sans,sans-serif', color:'var(--navy3)', background:'var(--white)', outline:'none', transition:'border 0.2s' }}
          onFocus={e => e.target.style.borderColor='var(--navy)'}
          onBlur={e => e.target.style.borderColor=errors[field]?'#e53e3e':'var(--graylt)'}
        />
      )}
      {errors[field] && <span style={{ fontSize:12, color:'#e53e3e', marginTop:4, display:'block' }}>{errors[field]}</span>}
    </div>
  );

  return (
    <section id="contact" style={{ padding:'100px 6%', background:'var(--offwhite)' }}>
      <RevealBox>
        <SectionLabel>Get In Touch</SectionLabel>
        <SectionTitle>Start Your Journey <em style={{ fontStyle:'italic' }}>Today</em></SectionTitle>
      </RevealBox>

      <div style={{ display:'grid', gridTemplateColumns:'1fr 1.3fr', gap:60, alignItems:'start', marginTop:56 }}>
        {/* Info side */}
        <RevealBox>
          <h3 style={{ fontSize:26, color:'var(--navy)', marginBottom:14 }}>Speak to an Expert Counsellor</h3>
          <p style={{ fontSize:16, color:'var(--gray)', lineHeight:1.7, marginBottom:32 }}>
            Our team of 30+ certified academic advisors are ready to guide you to the right program — completely free, zero pressure, zero obligation.
          </p>
          {details.map(d => (
            <div key={d.title} style={{
              display:'flex', alignItems:'center', gap:16, padding:'16px',
              background:'var(--white)', borderRadius:12, marginBottom:12,
              border:'1.5px solid var(--graylt)',
            }}>
              <div style={{
                width:46, height:46, background:'var(--navy)', borderRadius:10,
                display:'grid', placeItems:'center', fontSize:20, flexShrink:0,
              }}>{d.icon}</div>
              <div>
                <strong style={{ display:'block', fontSize:14, color:'var(--navy)', fontFamily:'DM Sans,sans-serif' }}>{d.title}</strong>
                <span style={{ fontSize:15, color:'var(--navy2)', fontWeight:600 }}>{d.info}</span>
                <span style={{ display:'block', fontSize:12, color:'var(--gray)' }}>{d.sub}</span>
              </div>
            </div>
          ))}

          {/* WhatsApp CTA */}
          <a href="https://wa.me/919136283227" target="_blank" rel="noreferrer" style={{
            display:'flex', alignItems:'center', gap:12, marginTop:24,
            background:'#25D366', color:'#fff', padding:'16px 24px', borderRadius:12,
            fontWeight:700, fontSize:15, transition:'all 0.25s', textDecoration:'none',
          }}
          onMouseEnter={e => { e.currentTarget.style.transform='translateY(-2px)'; e.currentTarget.style.boxShadow='0 8px 24px rgba(37,211,102,0.35)'; }}
          onMouseLeave={e => { e.currentTarget.style.transform='translateY(0)'; e.currentTarget.style.boxShadow='none'; }}
          >
            <svg width="22" height="22" viewBox="0 0 24 24" fill="#fff"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
            Chat on WhatsApp — Instant Response
          </a>

          {/* ── SOCIAL MEDIA LINKS ── */}
          <div style={{ marginTop:28 }}>
            <p style={{ fontSize:13, fontWeight:600, color:'var(--navy)', marginBottom:12, textTransform:'uppercase', letterSpacing:'0.05em' }}>
              Follow Us
            </p>
            <div style={{ display:'flex', gap:12 }}>
              {socials.map(s => (
                <a
                  key={s.name}
                  href={s.href}
                  target="_blank"
                  rel="noreferrer"
                  title={s.name}
                  style={{
                    display:'flex', alignItems:'center', gap:10,
                    background: s.color, color:'#fff',
                    padding:'10px 18px', borderRadius:10,
                    fontWeight:600, fontSize:14, textDecoration:'none',
                    transition:'all 0.25s', flexShrink:0,
                  }}
                  onMouseEnter={e => { e.currentTarget.style.transform='translateY(-2px)'; e.currentTarget.style.boxShadow=`0 8px 20px ${s.hoverShadow}`; }}
                  onMouseLeave={e => { e.currentTarget.style.transform='translateY(0)'; e.currentTarget.style.boxShadow='none'; }}
                >
                  {s.icon}
                  <span>{s.name}</span>
                </a>
              ))}
            </div>
          </div>
          {/* ── END SOCIAL MEDIA ── */}

        </RevealBox>

        {/* Form */}
        <RevealBox delay={0.15}>
          <div style={{ background:'var(--white)', border:'1.5px solid var(--graylt)', borderRadius:20, padding:40 }}>
            {step === 2 ? (
              <div style={{ textAlign:'center', padding:'40px 0' }}>
                <div style={{ fontSize:56, marginBottom:20 }}>🎉</div>
                <h3 style={{ fontSize:24, color:'var(--navy)', marginBottom:12 }}>Request Submitted!</h3>
                <p style={{ color:'var(--gray)', fontSize:16, lineHeight:1.7 }}>
                  Thank you, <strong>{form.name}</strong>! One of our expert counsellors will call you at <strong>{form.phone}</strong> within 2 hours.
                </p>
                <button onClick={() => { setStep(0); setForm({ name:'',phone:'',email:'',course:'',university:'',message:'' }); }}
                  style={{ marginTop:28, background:'var(--yellow)', color:'var(--navy)', border:'none', padding:'12px 28px', borderRadius:8, fontWeight:700, fontSize:15, cursor:'pointer', fontFamily:'DM Sans,sans-serif' }}>
                  Submit Another →
                </button>
              </div>
            ) : (
              <>
                <h3 style={{ fontSize:22, color:'var(--navy)', marginBottom:24 }}>Book Your Free Counselling</h3>
                <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:16, marginBottom:16 }}>
                  {inp('name','Full Name')}
                  {inp('phone','Phone Number','tel')}
                </div>
                <div style={{ marginBottom:16 }}>{inp('email','Email Address','email')}</div>
                <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:16, marginBottom:16 }}>
                  {inp('course','Select a Course','text',['MBA (Online)','MCA (Online)','MA (Online)','MCom (Online)','BBA (Online)','BCA (Online)','Diploma / Certificate'])}
                  {inp('university','Preferred University','text',['No preference','Amity University','DY Patil University','NMIMS','Manipal University','Chandigarh University'])}
                </div>
                <div style={{ marginBottom:24 }}>
                  <textarea placeholder="Tell us about your goals, background, or any questions..." value={form.message}
                    onChange={e => setForm({...form,message:e.target.value})}
                    style={{ width:'100%', border:'1.5px solid var(--graylt)', borderRadius:10, padding:'13px 16px', fontSize:15, fontFamily:'DM Sans,sans-serif', color:'var(--navy3)', background:'var(--white)', outline:'none', resize:'none', height:90 }}
                    onFocus={e => e.target.style.borderColor='var(--navy)'}
                    onBlur={e => e.target.style.borderColor='var(--graylt)'}
                  />
                </div>
                <button onClick={submit} disabled={step===1} style={{
                  width:'100%', background:'var(--navy)', color:'var(--yellow)',
                  border:'none', padding:'16px', borderRadius:10,
                  fontSize:16, fontWeight:700, cursor:'pointer', fontFamily:'DM Sans,sans-serif',
                  transition:'all 0.25s', opacity: step===1?0.7:1,
                }}>
                  {step===1 ? '⏳ Submitting...' : 'Get Free Counselling →'}
                </button>
                <p style={{ fontSize:12, color:'var(--gray)', textAlign:'center', marginTop:12 }}>
                  🔒 Your information is 100% secure. No spam, ever.
                </p>
              </>
            )}
          </div>
        </RevealBox>
      </div>
      <style>{`@media(max-width:860px){#contact-grid{grid-template-columns:1fr!important}}`}</style>
    </section>
  );
}